var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoInverseButtonClone4X(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "White",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.38,0,0,5.38,0,12s5.38,12,12,12,12-5.38,12-12S18.62,0,12,0ZM12,22c-5.51,0-10-4.49-10-10S6.49,2,12,2s10,4.49,10,10-4.49,10-10,10Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.41,8.16c-.39-.39-1.02-.39-1.41,0l-2.43,2.43-2.43-2.43c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l2.43,2.43-2.43,2.43c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l2.43-2.43,2.43,2.43c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.02,0-1.41l-2.43-2.43,2.43-2.43c.39-.39.39-1.02,0-1.41Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73,14.17h-3.74c-.53,0-.97-.39-.97-.92,0-.42.17-.74.47-1.09l3.95-4.59c.38-.44.66-.68,1.25-.68.53,0,.96.42.96.95v4.71h.48c.46,0,.82.36.82.82s-.36.81-.82.81h-.48v1.09c0,.53-.43.95-.96.95s-.95-.42-.95-.95v-1.09ZM7.73,12.55v-2.83l-2.42,2.83h2.42Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoInverseButtonClone4X);
export default __webpack_public_path__ + "static/media/kb-designer-ico-inverse-button-clone-4x.0022e43fd8a37cef2c8241b2f60828f6.svg";
export { ForwardRef as ReactComponent };